// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.2.0
//   protoc               v3.21.12
// source: main.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";

export const protobufPackage = "";

/** Define the DataAccidentalWritten enum */
export enum DataAccidentalWritten {
  ACCIDENTAL_WRITTEN_NONE = 0,
  ACCIDENTAL_WRITTEN_s = 1,
  ACCIDENTAL_WRITTEN_f = 2,
  ACCIDENTAL_WRITTEN_ss = 3,
  ACCIDENTAL_WRITTEN_x = 4,
  ACCIDENTAL_WRITTEN_ff = 5,
  ACCIDENTAL_WRITTEN_xs = 6,
  ACCIDENTAL_WRITTEN_sx = 7,
  ACCIDENTAL_WRITTEN_ts = 8,
  ACCIDENTAL_WRITTEN_tf = 9,
  ACCIDENTAL_WRITTEN_n = 10,
  ACCIDENTAL_WRITTEN_nf = 11,
  ACCIDENTAL_WRITTEN_ns = 12,
  ACCIDENTAL_WRITTEN_su = 13,
  ACCIDENTAL_WRITTEN_sd = 14,
  ACCIDENTAL_WRITTEN_fu = 15,
  ACCIDENTAL_WRITTEN_fd = 16,
  ACCIDENTAL_WRITTEN_nu = 17,
  ACCIDENTAL_WRITTEN_nd = 18,
  ACCIDENTAL_WRITTEN_xu = 19,
  ACCIDENTAL_WRITTEN_xd = 20,
  ACCIDENTAL_WRITTEN_ffu = 21,
  ACCIDENTAL_WRITTEN_ffd = 22,
  ACCIDENTAL_WRITTEN_1qf = 23,
  ACCIDENTAL_WRITTEN_3qf = 24,
  ACCIDENTAL_WRITTEN_1qs = 25,
  ACCIDENTAL_WRITTEN_3qs = 26,
  ACCIDENTAL_WRITTEN_bms = 27,
  ACCIDENTAL_WRITTEN_kms = 28,
  ACCIDENTAL_WRITTEN_bs = 29,
  ACCIDENTAL_WRITTEN_ks = 30,
  ACCIDENTAL_WRITTEN_kf = 31,
  ACCIDENTAL_WRITTEN_bf = 32,
  ACCIDENTAL_WRITTEN_kmf = 33,
  ACCIDENTAL_WRITTEN_bmf = 34,
  ACCIDENTAL_WRITTEN_koron = 35,
  ACCIDENTAL_WRITTEN_sori = 36,
  ACCIDENTAL_WRITTEN_MAX = 37,
  UNRECOGNIZED = -1,
}

export function dataAccidentalWrittenFromJSON(object: any): DataAccidentalWritten {
  switch (object) {
    case 0:
    case "ACCIDENTAL_WRITTEN_NONE":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_NONE;
    case 1:
    case "ACCIDENTAL_WRITTEN_s":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_s;
    case 2:
    case "ACCIDENTAL_WRITTEN_f":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_f;
    case 3:
    case "ACCIDENTAL_WRITTEN_ss":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_ss;
    case 4:
    case "ACCIDENTAL_WRITTEN_x":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_x;
    case 5:
    case "ACCIDENTAL_WRITTEN_ff":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_ff;
    case 6:
    case "ACCIDENTAL_WRITTEN_xs":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_xs;
    case 7:
    case "ACCIDENTAL_WRITTEN_sx":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_sx;
    case 8:
    case "ACCIDENTAL_WRITTEN_ts":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_ts;
    case 9:
    case "ACCIDENTAL_WRITTEN_tf":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_tf;
    case 10:
    case "ACCIDENTAL_WRITTEN_n":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_n;
    case 11:
    case "ACCIDENTAL_WRITTEN_nf":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_nf;
    case 12:
    case "ACCIDENTAL_WRITTEN_ns":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_ns;
    case 13:
    case "ACCIDENTAL_WRITTEN_su":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_su;
    case 14:
    case "ACCIDENTAL_WRITTEN_sd":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_sd;
    case 15:
    case "ACCIDENTAL_WRITTEN_fu":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_fu;
    case 16:
    case "ACCIDENTAL_WRITTEN_fd":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_fd;
    case 17:
    case "ACCIDENTAL_WRITTEN_nu":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_nu;
    case 18:
    case "ACCIDENTAL_WRITTEN_nd":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_nd;
    case 19:
    case "ACCIDENTAL_WRITTEN_xu":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_xu;
    case 20:
    case "ACCIDENTAL_WRITTEN_xd":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_xd;
    case 21:
    case "ACCIDENTAL_WRITTEN_ffu":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_ffu;
    case 22:
    case "ACCIDENTAL_WRITTEN_ffd":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_ffd;
    case 23:
    case "ACCIDENTAL_WRITTEN_1qf":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_1qf;
    case 24:
    case "ACCIDENTAL_WRITTEN_3qf":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_3qf;
    case 25:
    case "ACCIDENTAL_WRITTEN_1qs":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_1qs;
    case 26:
    case "ACCIDENTAL_WRITTEN_3qs":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_3qs;
    case 27:
    case "ACCIDENTAL_WRITTEN_bms":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_bms;
    case 28:
    case "ACCIDENTAL_WRITTEN_kms":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_kms;
    case 29:
    case "ACCIDENTAL_WRITTEN_bs":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_bs;
    case 30:
    case "ACCIDENTAL_WRITTEN_ks":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_ks;
    case 31:
    case "ACCIDENTAL_WRITTEN_kf":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_kf;
    case 32:
    case "ACCIDENTAL_WRITTEN_bf":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_bf;
    case 33:
    case "ACCIDENTAL_WRITTEN_kmf":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_kmf;
    case 34:
    case "ACCIDENTAL_WRITTEN_bmf":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_bmf;
    case 35:
    case "ACCIDENTAL_WRITTEN_koron":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_koron;
    case 36:
    case "ACCIDENTAL_WRITTEN_sori":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_sori;
    case 37:
    case "ACCIDENTAL_WRITTEN_MAX":
      return DataAccidentalWritten.ACCIDENTAL_WRITTEN_MAX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataAccidentalWritten.UNRECOGNIZED;
  }
}

export function dataAccidentalWrittenToJSON(object: DataAccidentalWritten): string {
  switch (object) {
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_NONE:
      return "ACCIDENTAL_WRITTEN_NONE";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_s:
      return "ACCIDENTAL_WRITTEN_s";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_f:
      return "ACCIDENTAL_WRITTEN_f";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_ss:
      return "ACCIDENTAL_WRITTEN_ss";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_x:
      return "ACCIDENTAL_WRITTEN_x";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_ff:
      return "ACCIDENTAL_WRITTEN_ff";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_xs:
      return "ACCIDENTAL_WRITTEN_xs";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_sx:
      return "ACCIDENTAL_WRITTEN_sx";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_ts:
      return "ACCIDENTAL_WRITTEN_ts";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_tf:
      return "ACCIDENTAL_WRITTEN_tf";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_n:
      return "ACCIDENTAL_WRITTEN_n";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_nf:
      return "ACCIDENTAL_WRITTEN_nf";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_ns:
      return "ACCIDENTAL_WRITTEN_ns";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_su:
      return "ACCIDENTAL_WRITTEN_su";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_sd:
      return "ACCIDENTAL_WRITTEN_sd";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_fu:
      return "ACCIDENTAL_WRITTEN_fu";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_fd:
      return "ACCIDENTAL_WRITTEN_fd";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_nu:
      return "ACCIDENTAL_WRITTEN_nu";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_nd:
      return "ACCIDENTAL_WRITTEN_nd";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_xu:
      return "ACCIDENTAL_WRITTEN_xu";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_xd:
      return "ACCIDENTAL_WRITTEN_xd";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_ffu:
      return "ACCIDENTAL_WRITTEN_ffu";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_ffd:
      return "ACCIDENTAL_WRITTEN_ffd";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_1qf:
      return "ACCIDENTAL_WRITTEN_1qf";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_3qf:
      return "ACCIDENTAL_WRITTEN_3qf";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_1qs:
      return "ACCIDENTAL_WRITTEN_1qs";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_3qs:
      return "ACCIDENTAL_WRITTEN_3qs";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_bms:
      return "ACCIDENTAL_WRITTEN_bms";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_kms:
      return "ACCIDENTAL_WRITTEN_kms";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_bs:
      return "ACCIDENTAL_WRITTEN_bs";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_ks:
      return "ACCIDENTAL_WRITTEN_ks";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_kf:
      return "ACCIDENTAL_WRITTEN_kf";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_bf:
      return "ACCIDENTAL_WRITTEN_bf";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_kmf:
      return "ACCIDENTAL_WRITTEN_kmf";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_bmf:
      return "ACCIDENTAL_WRITTEN_bmf";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_koron:
      return "ACCIDENTAL_WRITTEN_koron";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_sori:
      return "ACCIDENTAL_WRITTEN_sori";
    case DataAccidentalWritten.ACCIDENTAL_WRITTEN_MAX:
      return "ACCIDENTAL_WRITTEN_MAX";
    case DataAccidentalWritten.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum MistakeType {
  none = 0,
  tieNoteUnpressed = 1,
  UNRECOGNIZED = -1,
}

export function mistakeTypeFromJSON(object: any): MistakeType {
  switch (object) {
    case 0:
    case "none":
      return MistakeType.none;
    case 1:
    case "tieNoteUnpressed":
      return MistakeType.tieNoteUnpressed;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MistakeType.UNRECOGNIZED;
  }
}

export function mistakeTypeToJSON(object: MistakeType): string {
  switch (object) {
    case MistakeType.none:
      return "none";
    case MistakeType.tieNoteUnpressed:
      return "tieNoteUnpressed";
    case MistakeType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DataGrace {
  GRACE_NONE = 0,
  GRACE_acc = 1,
  GRACE_unacc = 2,
  GRACE_unknown = 3,
  GRACE_MAX = 4,
  UNRECOGNIZED = -1,
}

export function dataGraceFromJSON(object: any): DataGrace {
  switch (object) {
    case 0:
    case "GRACE_NONE":
      return DataGrace.GRACE_NONE;
    case 1:
    case "GRACE_acc":
      return DataGrace.GRACE_acc;
    case 2:
    case "GRACE_unacc":
      return DataGrace.GRACE_unacc;
    case 3:
    case "GRACE_unknown":
      return DataGrace.GRACE_unknown;
    case 4:
    case "GRACE_MAX":
      return DataGrace.GRACE_MAX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataGrace.UNRECOGNIZED;
  }
}

export function dataGraceToJSON(object: DataGrace): string {
  switch (object) {
    case DataGrace.GRACE_NONE:
      return "GRACE_NONE";
    case DataGrace.GRACE_acc:
      return "GRACE_acc";
    case DataGrace.GRACE_unacc:
      return "GRACE_unacc";
    case DataGrace.GRACE_unknown:
      return "GRACE_unknown";
    case DataGrace.GRACE_MAX:
      return "GRACE_MAX";
    case DataGrace.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DataMeasureBarline {
  NONE = 0,
  dashed = 1,
  dotted = 2,
  dbl = 3,
  dbldashed = 4,
  dbldotted = 5,
  dblheavy = 6,
  dblsegno = 7,
  end = 8,
  heavy = 9,
  invis = 10,
  rptstart = 11,
  rptboth = 12,
  rptend = 13,
  segno = 14,
  single = 15,
  MAX = 16,
  UNRECOGNIZED = -1,
}

export function dataMeasureBarlineFromJSON(object: any): DataMeasureBarline {
  switch (object) {
    case 0:
    case "NONE":
      return DataMeasureBarline.NONE;
    case 1:
    case "dashed":
      return DataMeasureBarline.dashed;
    case 2:
    case "dotted":
      return DataMeasureBarline.dotted;
    case 3:
    case "dbl":
      return DataMeasureBarline.dbl;
    case 4:
    case "dbldashed":
      return DataMeasureBarline.dbldashed;
    case 5:
    case "dbldotted":
      return DataMeasureBarline.dbldotted;
    case 6:
    case "dblheavy":
      return DataMeasureBarline.dblheavy;
    case 7:
    case "dblsegno":
      return DataMeasureBarline.dblsegno;
    case 8:
    case "end":
      return DataMeasureBarline.end;
    case 9:
    case "heavy":
      return DataMeasureBarline.heavy;
    case 10:
    case "invis":
      return DataMeasureBarline.invis;
    case 11:
    case "rptstart":
      return DataMeasureBarline.rptstart;
    case 12:
    case "rptboth":
      return DataMeasureBarline.rptboth;
    case 13:
    case "rptend":
      return DataMeasureBarline.rptend;
    case 14:
    case "segno":
      return DataMeasureBarline.segno;
    case 15:
    case "single":
      return DataMeasureBarline.single;
    case 16:
    case "MAX":
      return DataMeasureBarline.MAX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataMeasureBarline.UNRECOGNIZED;
  }
}

export function dataMeasureBarlineToJSON(object: DataMeasureBarline): string {
  switch (object) {
    case DataMeasureBarline.NONE:
      return "NONE";
    case DataMeasureBarline.dashed:
      return "dashed";
    case DataMeasureBarline.dotted:
      return "dotted";
    case DataMeasureBarline.dbl:
      return "dbl";
    case DataMeasureBarline.dbldashed:
      return "dbldashed";
    case DataMeasureBarline.dbldotted:
      return "dbldotted";
    case DataMeasureBarline.dblheavy:
      return "dblheavy";
    case DataMeasureBarline.dblsegno:
      return "dblsegno";
    case DataMeasureBarline.end:
      return "end";
    case DataMeasureBarline.heavy:
      return "heavy";
    case DataMeasureBarline.invis:
      return "invis";
    case DataMeasureBarline.rptstart:
      return "rptstart";
    case DataMeasureBarline.rptboth:
      return "rptboth";
    case DataMeasureBarline.rptend:
      return "rptend";
    case DataMeasureBarline.segno:
      return "segno";
    case DataMeasureBarline.single:
      return "single";
    case DataMeasureBarline.MAX:
      return "MAX";
    case DataMeasureBarline.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DataMode {
  MODE_NONE = 0,
  MODE_major = 1,
  MODE_minor = 2,
  MODE_dorian = 3,
  MODE_hypodorian = 4,
  MODE_phrygian = 5,
  MODE_hypophrygian = 6,
  MODE_lydian = 7,
  MODE_hypolydian = 8,
  MODE_mixolydian = 9,
  MODE_hypomixolydian = 10,
  MODE_peregrinus = 11,
  MODE_ionian = 12,
  MODE_hypoionian = 13,
  MODE_aeolian = 14,
  MODE_hypoaeolian = 15,
  MODE_locrian = 16,
  MODE_hypolocrian = 17,
  MODE_MAX = 18,
  UNRECOGNIZED = -1,
}

export function dataModeFromJSON(object: any): DataMode {
  switch (object) {
    case 0:
    case "MODE_NONE":
      return DataMode.MODE_NONE;
    case 1:
    case "MODE_major":
      return DataMode.MODE_major;
    case 2:
    case "MODE_minor":
      return DataMode.MODE_minor;
    case 3:
    case "MODE_dorian":
      return DataMode.MODE_dorian;
    case 4:
    case "MODE_hypodorian":
      return DataMode.MODE_hypodorian;
    case 5:
    case "MODE_phrygian":
      return DataMode.MODE_phrygian;
    case 6:
    case "MODE_hypophrygian":
      return DataMode.MODE_hypophrygian;
    case 7:
    case "MODE_lydian":
      return DataMode.MODE_lydian;
    case 8:
    case "MODE_hypolydian":
      return DataMode.MODE_hypolydian;
    case 9:
    case "MODE_mixolydian":
      return DataMode.MODE_mixolydian;
    case 10:
    case "MODE_hypomixolydian":
      return DataMode.MODE_hypomixolydian;
    case 11:
    case "MODE_peregrinus":
      return DataMode.MODE_peregrinus;
    case 12:
    case "MODE_ionian":
      return DataMode.MODE_ionian;
    case 13:
    case "MODE_hypoionian":
      return DataMode.MODE_hypoionian;
    case 14:
    case "MODE_aeolian":
      return DataMode.MODE_aeolian;
    case 15:
    case "MODE_hypoaeolian":
      return DataMode.MODE_hypoaeolian;
    case 16:
    case "MODE_locrian":
      return DataMode.MODE_locrian;
    case 17:
    case "MODE_hypolocrian":
      return DataMode.MODE_hypolocrian;
    case 18:
    case "MODE_MAX":
      return DataMode.MODE_MAX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataMode.UNRECOGNIZED;
  }
}

export function dataModeToJSON(object: DataMode): string {
  switch (object) {
    case DataMode.MODE_NONE:
      return "MODE_NONE";
    case DataMode.MODE_major:
      return "MODE_major";
    case DataMode.MODE_minor:
      return "MODE_minor";
    case DataMode.MODE_dorian:
      return "MODE_dorian";
    case DataMode.MODE_hypodorian:
      return "MODE_hypodorian";
    case DataMode.MODE_phrygian:
      return "MODE_phrygian";
    case DataMode.MODE_hypophrygian:
      return "MODE_hypophrygian";
    case DataMode.MODE_lydian:
      return "MODE_lydian";
    case DataMode.MODE_hypolydian:
      return "MODE_hypolydian";
    case DataMode.MODE_mixolydian:
      return "MODE_mixolydian";
    case DataMode.MODE_hypomixolydian:
      return "MODE_hypomixolydian";
    case DataMode.MODE_peregrinus:
      return "MODE_peregrinus";
    case DataMode.MODE_ionian:
      return "MODE_ionian";
    case DataMode.MODE_hypoionian:
      return "MODE_hypoionian";
    case DataMode.MODE_aeolian:
      return "MODE_aeolian";
    case DataMode.MODE_hypoaeolian:
      return "MODE_hypoaeolian";
    case DataMode.MODE_locrian:
      return "MODE_locrian";
    case DataMode.MODE_hypolocrian:
      return "MODE_hypolocrian";
    case DataMode.MODE_MAX:
      return "MODE_MAX";
    case DataMode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum DataClefshape {
  CLEFSHAPE_NONE = 0,
  CLEFSHAPE_G = 1,
  CLEFSHAPE_GG = 2,
  CLEFSHAPE_F = 3,
  CLEFSHAPE_C = 4,
  CLEFSHAPE_perc = 5,
  CLEFSHAPE_TAB = 6,
  CLEFSHAPE_MAX = 7,
  UNRECOGNIZED = -1,
}

export function dataClefshapeFromJSON(object: any): DataClefshape {
  switch (object) {
    case 0:
    case "CLEFSHAPE_NONE":
      return DataClefshape.CLEFSHAPE_NONE;
    case 1:
    case "CLEFSHAPE_G":
      return DataClefshape.CLEFSHAPE_G;
    case 2:
    case "CLEFSHAPE_GG":
      return DataClefshape.CLEFSHAPE_GG;
    case 3:
    case "CLEFSHAPE_F":
      return DataClefshape.CLEFSHAPE_F;
    case 4:
    case "CLEFSHAPE_C":
      return DataClefshape.CLEFSHAPE_C;
    case 5:
    case "CLEFSHAPE_perc":
      return DataClefshape.CLEFSHAPE_perc;
    case 6:
    case "CLEFSHAPE_TAB":
      return DataClefshape.CLEFSHAPE_TAB;
    case 7:
    case "CLEFSHAPE_MAX":
      return DataClefshape.CLEFSHAPE_MAX;
    case -1:
    case "UNRECOGNIZED":
    default:
      return DataClefshape.UNRECOGNIZED;
  }
}

export function dataClefshapeToJSON(object: DataClefshape): string {
  switch (object) {
    case DataClefshape.CLEFSHAPE_NONE:
      return "CLEFSHAPE_NONE";
    case DataClefshape.CLEFSHAPE_G:
      return "CLEFSHAPE_G";
    case DataClefshape.CLEFSHAPE_GG:
      return "CLEFSHAPE_GG";
    case DataClefshape.CLEFSHAPE_F:
      return "CLEFSHAPE_F";
    case DataClefshape.CLEFSHAPE_C:
      return "CLEFSHAPE_C";
    case DataClefshape.CLEFSHAPE_perc:
      return "CLEFSHAPE_perc";
    case DataClefshape.CLEFSHAPE_TAB:
      return "CLEFSHAPE_TAB";
    case DataClefshape.CLEFSHAPE_MAX:
      return "CLEFSHAPE_MAX";
    case DataClefshape.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export enum PlayerState {
  PLAYING = 0,
  REWIND = 1,
  PAUSE = 2,
  STOPPED = 3,
  ENDED = 4,
  PRACTICE = 5,
  UNRECOGNIZED = -1,
}

export function playerStateFromJSON(object: any): PlayerState {
  switch (object) {
    case 0:
    case "PLAYING":
      return PlayerState.PLAYING;
    case 1:
    case "REWIND":
      return PlayerState.REWIND;
    case 2:
    case "PAUSE":
      return PlayerState.PAUSE;
    case 3:
    case "STOPPED":
      return PlayerState.STOPPED;
    case 4:
    case "ENDED":
      return PlayerState.ENDED;
    case 5:
    case "PRACTICE":
      return PlayerState.PRACTICE;
    case -1:
    case "UNRECOGNIZED":
    default:
      return PlayerState.UNRECOGNIZED;
  }
}

export function playerStateToJSON(object: PlayerState): string {
  switch (object) {
    case PlayerState.PLAYING:
      return "PLAYING";
    case PlayerState.REWIND:
      return "REWIND";
    case PlayerState.PAUSE:
      return "PAUSE";
    case PlayerState.STOPPED:
      return "STOPPED";
    case PlayerState.ENDED:
      return "ENDED";
    case PlayerState.PRACTICE:
      return "PRACTICE";
    case PlayerState.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** Note status for rendering (matches NoteStatus in Types.h) */
export enum NoteStatus {
  Neutral = 0,
  Success = 1,
  Failed = 2,
  Highlighted = 3,
  UNRECOGNIZED = -1,
}

export function noteStatusFromJSON(object: any): NoteStatus {
  switch (object) {
    case 0:
    case "Neutral":
      return NoteStatus.Neutral;
    case 1:
    case "Success":
      return NoteStatus.Success;
    case 2:
    case "Failed":
      return NoteStatus.Failed;
    case 3:
    case "Highlighted":
      return NoteStatus.Highlighted;
    case -1:
    case "UNRECOGNIZED":
    default:
      return NoteStatus.UNRECOGNIZED;
  }
}

export function noteStatusToJSON(object: NoteStatus): string {
  switch (object) {
    case NoteStatus.Neutral:
      return "Neutral";
    case NoteStatus.Success:
      return "Success";
    case NoteStatus.Failed:
      return "Failed";
    case NoteStatus.Highlighted:
      return "Highlighted";
    case NoteStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * Selected hand (matches SELECTED_HAND in coreTypes.ts)
 * IMPORTANT: Proto3 requires first enum value to be 0
 * Original TS: NO_HAND=-1, RIGHT=0, LEFT=1
 * We shift all values: NO_HAND becomes 0 (was -1), RIGHT becomes 1 (was 0), LEFT becomes 2 (was 1)
 */
export enum SelectedHand {
  /** NO_HAND - Originally -1, now 0 for proto3 compliance */
  NO_HAND = 0,
  /** RIGHT - Originally 0, now 1 */
  RIGHT = 1,
  /** LEFT - Originally 1, now 2 */
  LEFT = 2,
  UNRECOGNIZED = -1,
}

export function selectedHandFromJSON(object: any): SelectedHand {
  switch (object) {
    case 0:
    case "NO_HAND":
      return SelectedHand.NO_HAND;
    case 1:
    case "RIGHT":
      return SelectedHand.RIGHT;
    case 2:
    case "LEFT":
      return SelectedHand.LEFT;
    case -1:
    case "UNRECOGNIZED":
    default:
      return SelectedHand.UNRECOGNIZED;
  }
}

export function selectedHandToJSON(object: SelectedHand): string {
  switch (object) {
    case SelectedHand.NO_HAND:
      return "NO_HAND";
    case SelectedHand.RIGHT:
      return "RIGHT";
    case SelectedHand.LEFT:
      return "LEFT";
    case SelectedHand.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/** MIDI message type (from Types.h) */
export enum MidiMessageType {
  NoteOn = 0,
  NoteOff = 1,
  ControlChange = 2,
  UNRECOGNIZED = -1,
}

export function midiMessageTypeFromJSON(object: any): MidiMessageType {
  switch (object) {
    case 0:
    case "NoteOn":
      return MidiMessageType.NoteOn;
    case 1:
    case "NoteOff":
      return MidiMessageType.NoteOff;
    case 2:
    case "ControlChange":
      return MidiMessageType.ControlChange;
    case -1:
    case "UNRECOGNIZED":
    default:
      return MidiMessageType.UNRECOGNIZED;
  }
}

export function midiMessageTypeToJSON(object: MidiMessageType): string {
  switch (object) {
    case MidiMessageType.NoteOn:
      return "NoteOn";
    case MidiMessageType.NoteOff:
      return "NoteOff";
    case MidiMessageType.ControlChange:
      return "ControlChange";
    case MidiMessageType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface UserMistakeBase {
  description: string;
  type: MistakeType;
}

/** Define the Attributes message */
export interface Attributes {
  cue: string;
  dur: string;
  /** Changed from 'dur.ppq' to 'durPpq' to adhere to Protobuf naming conventions */
  durPpq: string;
  oct: string;
  pname: string;
  /** Changed from 'stem.dir' to 'stemDir' to adhere to Protobuf naming conventions */
  stemDir: string;
}

/** Define the Note message */
export interface Note {
  noteId: string;
  measureIndex: number;
  measureStart: number;
  noteAbsoluteTime: number;
  noteTimeRelativeToMeasure: number;
  num: number;
  numBase: number;
  midi: midiValues | undefined;
  attributes:
    | Attributes
    | undefined;
  /**
   * -2 means double flat
   * -1 means flat
   * 0 means not accid
   * 1 means sharp
   * 2 means DoubleSharp
   */
  accid: number;
  ornamentsAccid: number;
  oct: number;
  step: string;
  /** 0 means right, 1 means left */
  hand: number;
  allNames: string[];
  nameInKey: string;
  prev: Note | undefined;
  next:
    | Note
    | undefined;
  /** this properties gets added later, after buildTimemap */
  unisonNoteChild: Note | undefined;
  unisonNoteParent: Note | undefined;
  isUnisonNoteChild: boolean;
  isUnisonNoteParent: boolean;
  velocityNoteOn?: number | undefined;
  velocityNoteOff?: number | undefined;
  ornamentNotes: Note[];
  timeNoteOnMidi?: number | undefined;
  timeNoteOffMidi?: number | undefined;
}

/** Define the midiValues message */
export interface midiValues {
  time: number;
  timeNoteOff: number;
  pitch: number;
  duration: number;
  xCoord: number;
  yCoord: number;
  staffPos: number;
  grace: DataGrace;
  indexInXmlParent: number;
  /** Use the Tie message */
  ties: Tie[];
  /** Use the Slur message */
  slurs: Slur[];
  /** Use the Turn message */
  turn:
    | Turn
    | undefined;
  /** Use the Trill message */
  trill:
    | Trill
    | undefined;
  /** Use the Mordent message */
  mordent: Mordent | undefined;
  trem: Trem | undefined;
}

export interface Trem {
  singleTrem: boolean;
  noteIds: string[];
}

/** Define the Slur message */
export interface Slur {
  slurId: string;
  slurStartId: string;
  slurEndId: string;
}

/** Define the Tie message */
export interface Tie {
  tieStartId: string;
  tieEndId: string;
  tieId: string;
  /** Note is another message you will define */
  startNote: Note | undefined;
}

/** Define the Trill message */
export interface Trill {
  id: string;
  /** "upper" or "lower" */
  position: string;
  trillStartNote: string;
  trillEndNote?: string | undefined;
  accid: DataAccidentalWritten;
  waveLengthEndOffset: number;
  waveEndXRel: number;
}

/** Define the Turn message */
export interface Turn {
  id: string;
  /** "upper" or "lower" */
  position: string;
  turnRootNote: string;
}

/** Define the Mordent message */
export interface Mordent {
  id: string;
  /** "upper" or "lower" */
  position: string;
  mordentRootNote: string;
  /** 1 or 0 */
  isLong: number;
}

export interface MeasureTimemapEntry {
  measureIndex: number;
  measureId: string;
  measureLeftBar: DataMeasureBarline;
  measureRightBar: DataMeasureBarline;
  volta: volta | undefined;
  indexInXmlParent: number;
  timestamp: number;
  clefs: clef[];
  keyFifths: number;
  keyMode: DataMode;
  notes: Note[];
}

export interface volta {
  endingStart: ending | undefined;
  endingStop: ending | undefined;
}

export interface ending {
  endingNumber: string;
  endingText: string;
  endingType: string;
}

export interface clef {
  shape: DataClefshape;
  line: number;
}

/** this is code for MIDI mapper */
export interface ornamentNotesIndToDelete {
  parentOrnamentNote: Note | undefined;
  measureIndex: number;
  eventIndexes: number[];
}

export interface midiNoteEvent {
  tick: number;
  noteNumber: number;
  noteName: string;
  velocity: number;
  channel: number;
}

export interface MidiEvents {
  noteOnEvents: midiNoteEvent[];
  noteOffEvents: midiNoteEvent[];
}

export interface PossibleEncountersData {
  possibleEncounters: Note[];
}

/** Coordinate in the sheet (matches Coord in coreTypes.ts) */
export interface Coord {
  measure: number;
  offset: number;
  xCoord: number;
  yCoord: number;
  absoluteTime: number;
}

/** Selection range (matches IRange in coreTypes.ts) */
export interface SelectionRange {
  start?: Coord | undefined;
  end?: Coord | undefined;
}

/** Cursor position for UI callbacks (from Types.h) */
export interface CursorPosition {
  noteId: string;
  measureIndex: number;
  x: number;
  y: number;
  /** Percentage within measure */
  relativeX: number;
  systemIndex: number;
}

/** MIDI message (from Types.h) */
export interface MidiMessage {
  type: MidiMessageType;
  noteNumber: number;
  velocity: number;
  channel: number;
  timestamp: number;
}

function createBaseUserMistakeBase(): UserMistakeBase {
  return { description: "", type: 0 };
}

export const UserMistakeBase: MessageFns<UserMistakeBase> = {
  encode(message: UserMistakeBase, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.description !== "") {
      writer.uint32(10).string(message.description);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): UserMistakeBase {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUserMistakeBase();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.description = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UserMistakeBase {
    return {
      description: isSet(object.description) ? globalThis.String(object.description) : "",
      type: isSet(object.type) ? mistakeTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: UserMistakeBase): unknown {
    const obj: any = {};
    if (message.description !== "") {
      obj.description = message.description;
    }
    if (message.type !== 0) {
      obj.type = mistakeTypeToJSON(message.type);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UserMistakeBase>, I>>(base?: I): UserMistakeBase {
    return UserMistakeBase.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UserMistakeBase>, I>>(object: I): UserMistakeBase {
    const message = createBaseUserMistakeBase();
    message.description = object.description ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseAttributes(): Attributes {
  return { cue: "", dur: "", durPpq: "", oct: "", pname: "", stemDir: "" };
}

export const Attributes: MessageFns<Attributes> = {
  encode(message: Attributes, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.cue !== "") {
      writer.uint32(10).string(message.cue);
    }
    if (message.dur !== "") {
      writer.uint32(18).string(message.dur);
    }
    if (message.durPpq !== "") {
      writer.uint32(26).string(message.durPpq);
    }
    if (message.oct !== "") {
      writer.uint32(34).string(message.oct);
    }
    if (message.pname !== "") {
      writer.uint32(42).string(message.pname);
    }
    if (message.stemDir !== "") {
      writer.uint32(50).string(message.stemDir);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Attributes {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAttributes();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.cue = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.dur = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.durPpq = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.oct = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.pname = reader.string();
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.stemDir = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Attributes {
    return {
      cue: isSet(object.cue) ? globalThis.String(object.cue) : "",
      dur: isSet(object.dur) ? globalThis.String(object.dur) : "",
      durPpq: isSet(object.durPpq) ? globalThis.String(object.durPpq) : "",
      oct: isSet(object.oct) ? globalThis.String(object.oct) : "",
      pname: isSet(object.pname) ? globalThis.String(object.pname) : "",
      stemDir: isSet(object.stemDir) ? globalThis.String(object.stemDir) : "",
    };
  },

  toJSON(message: Attributes): unknown {
    const obj: any = {};
    if (message.cue !== "") {
      obj.cue = message.cue;
    }
    if (message.dur !== "") {
      obj.dur = message.dur;
    }
    if (message.durPpq !== "") {
      obj.durPpq = message.durPpq;
    }
    if (message.oct !== "") {
      obj.oct = message.oct;
    }
    if (message.pname !== "") {
      obj.pname = message.pname;
    }
    if (message.stemDir !== "") {
      obj.stemDir = message.stemDir;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Attributes>, I>>(base?: I): Attributes {
    return Attributes.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Attributes>, I>>(object: I): Attributes {
    const message = createBaseAttributes();
    message.cue = object.cue ?? "";
    message.dur = object.dur ?? "";
    message.durPpq = object.durPpq ?? "";
    message.oct = object.oct ?? "";
    message.pname = object.pname ?? "";
    message.stemDir = object.stemDir ?? "";
    return message;
  },
};

function createBaseNote(): Note {
  return {
    noteId: "",
    measureIndex: 0,
    measureStart: 0,
    noteAbsoluteTime: 0,
    noteTimeRelativeToMeasure: 0,
    num: 0,
    numBase: 0,
    midi: undefined,
    attributes: undefined,
    accid: 0,
    ornamentsAccid: 0,
    oct: 0,
    step: "",
    hand: 0,
    allNames: [],
    nameInKey: "",
    prev: undefined,
    next: undefined,
    unisonNoteChild: undefined,
    unisonNoteParent: undefined,
    isUnisonNoteChild: false,
    isUnisonNoteParent: false,
    velocityNoteOn: undefined,
    velocityNoteOff: undefined,
    ornamentNotes: [],
    timeNoteOnMidi: undefined,
    timeNoteOffMidi: undefined,
  };
}

export const Note: MessageFns<Note> = {
  encode(message: Note, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.noteId !== "") {
      writer.uint32(10).string(message.noteId);
    }
    if (message.measureIndex !== 0) {
      writer.uint32(16).int32(message.measureIndex);
    }
    if (message.measureStart !== 0) {
      writer.uint32(24).int32(message.measureStart);
    }
    if (message.noteAbsoluteTime !== 0) {
      writer.uint32(32).int32(message.noteAbsoluteTime);
    }
    if (message.noteTimeRelativeToMeasure !== 0) {
      writer.uint32(40).int32(message.noteTimeRelativeToMeasure);
    }
    if (message.num !== 0) {
      writer.uint32(48).int32(message.num);
    }
    if (message.numBase !== 0) {
      writer.uint32(56).int32(message.numBase);
    }
    if (message.midi !== undefined) {
      midiValues.encode(message.midi, writer.uint32(66).fork()).join();
    }
    if (message.attributes !== undefined) {
      Attributes.encode(message.attributes, writer.uint32(74).fork()).join();
    }
    if (message.accid !== 0) {
      writer.uint32(80).int32(message.accid);
    }
    if (message.ornamentsAccid !== 0) {
      writer.uint32(88).int32(message.ornamentsAccid);
    }
    if (message.oct !== 0) {
      writer.uint32(96).int32(message.oct);
    }
    if (message.step !== "") {
      writer.uint32(106).string(message.step);
    }
    if (message.hand !== 0) {
      writer.uint32(112).int32(message.hand);
    }
    for (const v of message.allNames) {
      writer.uint32(122).string(v!);
    }
    if (message.nameInKey !== "") {
      writer.uint32(130).string(message.nameInKey);
    }
    if (message.prev !== undefined) {
      Note.encode(message.prev, writer.uint32(138).fork()).join();
    }
    if (message.next !== undefined) {
      Note.encode(message.next, writer.uint32(146).fork()).join();
    }
    if (message.unisonNoteChild !== undefined) {
      Note.encode(message.unisonNoteChild, writer.uint32(154).fork()).join();
    }
    if (message.unisonNoteParent !== undefined) {
      Note.encode(message.unisonNoteParent, writer.uint32(162).fork()).join();
    }
    if (message.isUnisonNoteChild !== false) {
      writer.uint32(168).bool(message.isUnisonNoteChild);
    }
    if (message.isUnisonNoteParent !== false) {
      writer.uint32(176).bool(message.isUnisonNoteParent);
    }
    if (message.velocityNoteOn !== undefined) {
      writer.uint32(184).int32(message.velocityNoteOn);
    }
    if (message.velocityNoteOff !== undefined) {
      writer.uint32(192).int32(message.velocityNoteOff);
    }
    for (const v of message.ornamentNotes) {
      Note.encode(v!, writer.uint32(202).fork()).join();
    }
    if (message.timeNoteOnMidi !== undefined) {
      writer.uint32(208).int32(message.timeNoteOnMidi);
    }
    if (message.timeNoteOffMidi !== undefined) {
      writer.uint32(216).int32(message.timeNoteOffMidi);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Note {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseNote();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.noteId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.measureIndex = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.measureStart = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.noteAbsoluteTime = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.noteTimeRelativeToMeasure = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.num = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.numBase = reader.int32();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.midi = midiValues.decode(reader, reader.uint32());
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.attributes = Attributes.decode(reader, reader.uint32());
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.accid = reader.int32();
          continue;
        case 11:
          if (tag !== 88) {
            break;
          }

          message.ornamentsAccid = reader.int32();
          continue;
        case 12:
          if (tag !== 96) {
            break;
          }

          message.oct = reader.int32();
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.step = reader.string();
          continue;
        case 14:
          if (tag !== 112) {
            break;
          }

          message.hand = reader.int32();
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.allNames.push(reader.string());
          continue;
        case 16:
          if (tag !== 130) {
            break;
          }

          message.nameInKey = reader.string();
          continue;
        case 17:
          if (tag !== 138) {
            break;
          }

          message.prev = Note.decode(reader, reader.uint32());
          continue;
        case 18:
          if (tag !== 146) {
            break;
          }

          message.next = Note.decode(reader, reader.uint32());
          continue;
        case 19:
          if (tag !== 154) {
            break;
          }

          message.unisonNoteChild = Note.decode(reader, reader.uint32());
          continue;
        case 20:
          if (tag !== 162) {
            break;
          }

          message.unisonNoteParent = Note.decode(reader, reader.uint32());
          continue;
        case 21:
          if (tag !== 168) {
            break;
          }

          message.isUnisonNoteChild = reader.bool();
          continue;
        case 22:
          if (tag !== 176) {
            break;
          }

          message.isUnisonNoteParent = reader.bool();
          continue;
        case 23:
          if (tag !== 184) {
            break;
          }

          message.velocityNoteOn = reader.int32();
          continue;
        case 24:
          if (tag !== 192) {
            break;
          }

          message.velocityNoteOff = reader.int32();
          continue;
        case 25:
          if (tag !== 202) {
            break;
          }

          message.ornamentNotes.push(Note.decode(reader, reader.uint32()));
          continue;
        case 26:
          if (tag !== 208) {
            break;
          }

          message.timeNoteOnMidi = reader.int32();
          continue;
        case 27:
          if (tag !== 216) {
            break;
          }

          message.timeNoteOffMidi = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Note {
    return {
      noteId: isSet(object.noteId) ? globalThis.String(object.noteId) : "",
      measureIndex: isSet(object.measureIndex) ? globalThis.Number(object.measureIndex) : 0,
      measureStart: isSet(object.measureStart) ? globalThis.Number(object.measureStart) : 0,
      noteAbsoluteTime: isSet(object.noteAbsoluteTime) ? globalThis.Number(object.noteAbsoluteTime) : 0,
      noteTimeRelativeToMeasure: isSet(object.noteTimeRelativeToMeasure)
        ? globalThis.Number(object.noteTimeRelativeToMeasure)
        : 0,
      num: isSet(object.num) ? globalThis.Number(object.num) : 0,
      numBase: isSet(object.numBase) ? globalThis.Number(object.numBase) : 0,
      midi: isSet(object.midi) ? midiValues.fromJSON(object.midi) : undefined,
      attributes: isSet(object.attributes) ? Attributes.fromJSON(object.attributes) : undefined,
      accid: isSet(object.accid) ? globalThis.Number(object.accid) : 0,
      ornamentsAccid: isSet(object.ornamentsAccid) ? globalThis.Number(object.ornamentsAccid) : 0,
      oct: isSet(object.oct) ? globalThis.Number(object.oct) : 0,
      step: isSet(object.step) ? globalThis.String(object.step) : "",
      hand: isSet(object.hand) ? globalThis.Number(object.hand) : 0,
      allNames: globalThis.Array.isArray(object?.allNames) ? object.allNames.map((e: any) => globalThis.String(e)) : [],
      nameInKey: isSet(object.nameInKey) ? globalThis.String(object.nameInKey) : "",
      prev: isSet(object.prev) ? Note.fromJSON(object.prev) : undefined,
      next: isSet(object.next) ? Note.fromJSON(object.next) : undefined,
      unisonNoteChild: isSet(object.unisonNoteChild) ? Note.fromJSON(object.unisonNoteChild) : undefined,
      unisonNoteParent: isSet(object.unisonNoteParent) ? Note.fromJSON(object.unisonNoteParent) : undefined,
      isUnisonNoteChild: isSet(object.isUnisonNoteChild) ? globalThis.Boolean(object.isUnisonNoteChild) : false,
      isUnisonNoteParent: isSet(object.isUnisonNoteParent) ? globalThis.Boolean(object.isUnisonNoteParent) : false,
      velocityNoteOn: isSet(object.velocityNoteOn) ? globalThis.Number(object.velocityNoteOn) : undefined,
      velocityNoteOff: isSet(object.velocityNoteOff) ? globalThis.Number(object.velocityNoteOff) : undefined,
      ornamentNotes: globalThis.Array.isArray(object?.ornamentNotes)
        ? object.ornamentNotes.map((e: any) => Note.fromJSON(e))
        : [],
      timeNoteOnMidi: isSet(object.timeNoteOnMidi) ? globalThis.Number(object.timeNoteOnMidi) : undefined,
      timeNoteOffMidi: isSet(object.timeNoteOffMidi) ? globalThis.Number(object.timeNoteOffMidi) : undefined,
    };
  },

  toJSON(message: Note): unknown {
    const obj: any = {};
    if (message.noteId !== "") {
      obj.noteId = message.noteId;
    }
    if (message.measureIndex !== 0) {
      obj.measureIndex = Math.round(message.measureIndex);
    }
    if (message.measureStart !== 0) {
      obj.measureStart = Math.round(message.measureStart);
    }
    if (message.noteAbsoluteTime !== 0) {
      obj.noteAbsoluteTime = Math.round(message.noteAbsoluteTime);
    }
    if (message.noteTimeRelativeToMeasure !== 0) {
      obj.noteTimeRelativeToMeasure = Math.round(message.noteTimeRelativeToMeasure);
    }
    if (message.num !== 0) {
      obj.num = Math.round(message.num);
    }
    if (message.numBase !== 0) {
      obj.numBase = Math.round(message.numBase);
    }
    if (message.midi !== undefined) {
      obj.midi = midiValues.toJSON(message.midi);
    }
    if (message.attributes !== undefined) {
      obj.attributes = Attributes.toJSON(message.attributes);
    }
    if (message.accid !== 0) {
      obj.accid = Math.round(message.accid);
    }
    if (message.ornamentsAccid !== 0) {
      obj.ornamentsAccid = Math.round(message.ornamentsAccid);
    }
    if (message.oct !== 0) {
      obj.oct = Math.round(message.oct);
    }
    if (message.step !== "") {
      obj.step = message.step;
    }
    if (message.hand !== 0) {
      obj.hand = Math.round(message.hand);
    }
    if (message.allNames?.length) {
      obj.allNames = message.allNames;
    }
    if (message.nameInKey !== "") {
      obj.nameInKey = message.nameInKey;
    }
    if (message.prev !== undefined) {
      obj.prev = Note.toJSON(message.prev);
    }
    if (message.next !== undefined) {
      obj.next = Note.toJSON(message.next);
    }
    if (message.unisonNoteChild !== undefined) {
      obj.unisonNoteChild = Note.toJSON(message.unisonNoteChild);
    }
    if (message.unisonNoteParent !== undefined) {
      obj.unisonNoteParent = Note.toJSON(message.unisonNoteParent);
    }
    if (message.isUnisonNoteChild !== false) {
      obj.isUnisonNoteChild = message.isUnisonNoteChild;
    }
    if (message.isUnisonNoteParent !== false) {
      obj.isUnisonNoteParent = message.isUnisonNoteParent;
    }
    if (message.velocityNoteOn !== undefined) {
      obj.velocityNoteOn = Math.round(message.velocityNoteOn);
    }
    if (message.velocityNoteOff !== undefined) {
      obj.velocityNoteOff = Math.round(message.velocityNoteOff);
    }
    if (message.ornamentNotes?.length) {
      obj.ornamentNotes = message.ornamentNotes.map((e) => Note.toJSON(e));
    }
    if (message.timeNoteOnMidi !== undefined) {
      obj.timeNoteOnMidi = Math.round(message.timeNoteOnMidi);
    }
    if (message.timeNoteOffMidi !== undefined) {
      obj.timeNoteOffMidi = Math.round(message.timeNoteOffMidi);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Note>, I>>(base?: I): Note {
    return Note.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Note>, I>>(object: I): Note {
    const message = createBaseNote();
    message.noteId = object.noteId ?? "";
    message.measureIndex = object.measureIndex ?? 0;
    message.measureStart = object.measureStart ?? 0;
    message.noteAbsoluteTime = object.noteAbsoluteTime ?? 0;
    message.noteTimeRelativeToMeasure = object.noteTimeRelativeToMeasure ?? 0;
    message.num = object.num ?? 0;
    message.numBase = object.numBase ?? 0;
    message.midi = (object.midi !== undefined && object.midi !== null)
      ? midiValues.fromPartial(object.midi)
      : undefined;
    message.attributes = (object.attributes !== undefined && object.attributes !== null)
      ? Attributes.fromPartial(object.attributes)
      : undefined;
    message.accid = object.accid ?? 0;
    message.ornamentsAccid = object.ornamentsAccid ?? 0;
    message.oct = object.oct ?? 0;
    message.step = object.step ?? "";
    message.hand = object.hand ?? 0;
    message.allNames = object.allNames?.map((e) => e) || [];
    message.nameInKey = object.nameInKey ?? "";
    message.prev = (object.prev !== undefined && object.prev !== null) ? Note.fromPartial(object.prev) : undefined;
    message.next = (object.next !== undefined && object.next !== null) ? Note.fromPartial(object.next) : undefined;
    message.unisonNoteChild = (object.unisonNoteChild !== undefined && object.unisonNoteChild !== null)
      ? Note.fromPartial(object.unisonNoteChild)
      : undefined;
    message.unisonNoteParent = (object.unisonNoteParent !== undefined && object.unisonNoteParent !== null)
      ? Note.fromPartial(object.unisonNoteParent)
      : undefined;
    message.isUnisonNoteChild = object.isUnisonNoteChild ?? false;
    message.isUnisonNoteParent = object.isUnisonNoteParent ?? false;
    message.velocityNoteOn = object.velocityNoteOn ?? undefined;
    message.velocityNoteOff = object.velocityNoteOff ?? undefined;
    message.ornamentNotes = object.ornamentNotes?.map((e) => Note.fromPartial(e)) || [];
    message.timeNoteOnMidi = object.timeNoteOnMidi ?? undefined;
    message.timeNoteOffMidi = object.timeNoteOffMidi ?? undefined;
    return message;
  },
};

function createBasemidiValues(): midiValues {
  return {
    time: 0,
    timeNoteOff: 0,
    pitch: 0,
    duration: 0,
    xCoord: 0,
    yCoord: 0,
    staffPos: 0,
    grace: 0,
    indexInXmlParent: 0,
    ties: [],
    slurs: [],
    turn: undefined,
    trill: undefined,
    mordent: undefined,
    trem: undefined,
  };
}

export const midiValues: MessageFns<midiValues> = {
  encode(message: midiValues, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.time !== 0) {
      writer.uint32(8).int32(message.time);
    }
    if (message.timeNoteOff !== 0) {
      writer.uint32(16).int32(message.timeNoteOff);
    }
    if (message.pitch !== 0) {
      writer.uint32(24).int32(message.pitch);
    }
    if (message.duration !== 0) {
      writer.uint32(32).int32(message.duration);
    }
    if (message.xCoord !== 0) {
      writer.uint32(40).int32(message.xCoord);
    }
    if (message.yCoord !== 0) {
      writer.uint32(48).int32(message.yCoord);
    }
    if (message.staffPos !== 0) {
      writer.uint32(56).int32(message.staffPos);
    }
    if (message.grace !== 0) {
      writer.uint32(64).int32(message.grace);
    }
    if (message.indexInXmlParent !== 0) {
      writer.uint32(72).int32(message.indexInXmlParent);
    }
    for (const v of message.ties) {
      Tie.encode(v!, writer.uint32(82).fork()).join();
    }
    for (const v of message.slurs) {
      Slur.encode(v!, writer.uint32(90).fork()).join();
    }
    if (message.turn !== undefined) {
      Turn.encode(message.turn, writer.uint32(98).fork()).join();
    }
    if (message.trill !== undefined) {
      Trill.encode(message.trill, writer.uint32(106).fork()).join();
    }
    if (message.mordent !== undefined) {
      Mordent.encode(message.mordent, writer.uint32(114).fork()).join();
    }
    if (message.trem !== undefined) {
      Trem.encode(message.trem, writer.uint32(122).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): midiValues {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasemidiValues();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.time = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.timeNoteOff = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.pitch = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.duration = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.xCoord = reader.int32();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.yCoord = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.staffPos = reader.int32();
          continue;
        case 8:
          if (tag !== 64) {
            break;
          }

          message.grace = reader.int32() as any;
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.indexInXmlParent = reader.int32();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.ties.push(Tie.decode(reader, reader.uint32()));
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.slurs.push(Slur.decode(reader, reader.uint32()));
          continue;
        case 12:
          if (tag !== 98) {
            break;
          }

          message.turn = Turn.decode(reader, reader.uint32());
          continue;
        case 13:
          if (tag !== 106) {
            break;
          }

          message.trill = Trill.decode(reader, reader.uint32());
          continue;
        case 14:
          if (tag !== 114) {
            break;
          }

          message.mordent = Mordent.decode(reader, reader.uint32());
          continue;
        case 15:
          if (tag !== 122) {
            break;
          }

          message.trem = Trem.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): midiValues {
    return {
      time: isSet(object.time) ? globalThis.Number(object.time) : 0,
      timeNoteOff: isSet(object.timeNoteOff) ? globalThis.Number(object.timeNoteOff) : 0,
      pitch: isSet(object.pitch) ? globalThis.Number(object.pitch) : 0,
      duration: isSet(object.duration) ? globalThis.Number(object.duration) : 0,
      xCoord: isSet(object.xCoord) ? globalThis.Number(object.xCoord) : 0,
      yCoord: isSet(object.yCoord) ? globalThis.Number(object.yCoord) : 0,
      staffPos: isSet(object.staffPos) ? globalThis.Number(object.staffPos) : 0,
      grace: isSet(object.grace) ? dataGraceFromJSON(object.grace) : 0,
      indexInXmlParent: isSet(object.indexInXmlParent) ? globalThis.Number(object.indexInXmlParent) : 0,
      ties: globalThis.Array.isArray(object?.ties) ? object.ties.map((e: any) => Tie.fromJSON(e)) : [],
      slurs: globalThis.Array.isArray(object?.slurs) ? object.slurs.map((e: any) => Slur.fromJSON(e)) : [],
      turn: isSet(object.turn) ? Turn.fromJSON(object.turn) : undefined,
      trill: isSet(object.trill) ? Trill.fromJSON(object.trill) : undefined,
      mordent: isSet(object.mordent) ? Mordent.fromJSON(object.mordent) : undefined,
      trem: isSet(object.trem) ? Trem.fromJSON(object.trem) : undefined,
    };
  },

  toJSON(message: midiValues): unknown {
    const obj: any = {};
    if (message.time !== 0) {
      obj.time = Math.round(message.time);
    }
    if (message.timeNoteOff !== 0) {
      obj.timeNoteOff = Math.round(message.timeNoteOff);
    }
    if (message.pitch !== 0) {
      obj.pitch = Math.round(message.pitch);
    }
    if (message.duration !== 0) {
      obj.duration = Math.round(message.duration);
    }
    if (message.xCoord !== 0) {
      obj.xCoord = Math.round(message.xCoord);
    }
    if (message.yCoord !== 0) {
      obj.yCoord = Math.round(message.yCoord);
    }
    if (message.staffPos !== 0) {
      obj.staffPos = Math.round(message.staffPos);
    }
    if (message.grace !== 0) {
      obj.grace = dataGraceToJSON(message.grace);
    }
    if (message.indexInXmlParent !== 0) {
      obj.indexInXmlParent = Math.round(message.indexInXmlParent);
    }
    if (message.ties?.length) {
      obj.ties = message.ties.map((e) => Tie.toJSON(e));
    }
    if (message.slurs?.length) {
      obj.slurs = message.slurs.map((e) => Slur.toJSON(e));
    }
    if (message.turn !== undefined) {
      obj.turn = Turn.toJSON(message.turn);
    }
    if (message.trill !== undefined) {
      obj.trill = Trill.toJSON(message.trill);
    }
    if (message.mordent !== undefined) {
      obj.mordent = Mordent.toJSON(message.mordent);
    }
    if (message.trem !== undefined) {
      obj.trem = Trem.toJSON(message.trem);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<midiValues>, I>>(base?: I): midiValues {
    return midiValues.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<midiValues>, I>>(object: I): midiValues {
    const message = createBasemidiValues();
    message.time = object.time ?? 0;
    message.timeNoteOff = object.timeNoteOff ?? 0;
    message.pitch = object.pitch ?? 0;
    message.duration = object.duration ?? 0;
    message.xCoord = object.xCoord ?? 0;
    message.yCoord = object.yCoord ?? 0;
    message.staffPos = object.staffPos ?? 0;
    message.grace = object.grace ?? 0;
    message.indexInXmlParent = object.indexInXmlParent ?? 0;
    message.ties = object.ties?.map((e) => Tie.fromPartial(e)) || [];
    message.slurs = object.slurs?.map((e) => Slur.fromPartial(e)) || [];
    message.turn = (object.turn !== undefined && object.turn !== null) ? Turn.fromPartial(object.turn) : undefined;
    message.trill = (object.trill !== undefined && object.trill !== null) ? Trill.fromPartial(object.trill) : undefined;
    message.mordent = (object.mordent !== undefined && object.mordent !== null)
      ? Mordent.fromPartial(object.mordent)
      : undefined;
    message.trem = (object.trem !== undefined && object.trem !== null) ? Trem.fromPartial(object.trem) : undefined;
    return message;
  },
};

function createBaseTrem(): Trem {
  return { singleTrem: false, noteIds: [] };
}

export const Trem: MessageFns<Trem> = {
  encode(message: Trem, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.singleTrem !== false) {
      writer.uint32(8).bool(message.singleTrem);
    }
    for (const v of message.noteIds) {
      writer.uint32(18).string(v!);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Trem {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrem();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.singleTrem = reader.bool();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.noteIds.push(reader.string());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Trem {
    return {
      singleTrem: isSet(object.singleTrem) ? globalThis.Boolean(object.singleTrem) : false,
      noteIds: globalThis.Array.isArray(object?.noteIds) ? object.noteIds.map((e: any) => globalThis.String(e)) : [],
    };
  },

  toJSON(message: Trem): unknown {
    const obj: any = {};
    if (message.singleTrem !== false) {
      obj.singleTrem = message.singleTrem;
    }
    if (message.noteIds?.length) {
      obj.noteIds = message.noteIds;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Trem>, I>>(base?: I): Trem {
    return Trem.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Trem>, I>>(object: I): Trem {
    const message = createBaseTrem();
    message.singleTrem = object.singleTrem ?? false;
    message.noteIds = object.noteIds?.map((e) => e) || [];
    return message;
  },
};

function createBaseSlur(): Slur {
  return { slurId: "", slurStartId: "", slurEndId: "" };
}

export const Slur: MessageFns<Slur> = {
  encode(message: Slur, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.slurId !== "") {
      writer.uint32(10).string(message.slurId);
    }
    if (message.slurStartId !== "") {
      writer.uint32(18).string(message.slurStartId);
    }
    if (message.slurEndId !== "") {
      writer.uint32(26).string(message.slurEndId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Slur {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSlur();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.slurId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.slurStartId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.slurEndId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Slur {
    return {
      slurId: isSet(object.slurId) ? globalThis.String(object.slurId) : "",
      slurStartId: isSet(object.slurStartId) ? globalThis.String(object.slurStartId) : "",
      slurEndId: isSet(object.slurEndId) ? globalThis.String(object.slurEndId) : "",
    };
  },

  toJSON(message: Slur): unknown {
    const obj: any = {};
    if (message.slurId !== "") {
      obj.slurId = message.slurId;
    }
    if (message.slurStartId !== "") {
      obj.slurStartId = message.slurStartId;
    }
    if (message.slurEndId !== "") {
      obj.slurEndId = message.slurEndId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Slur>, I>>(base?: I): Slur {
    return Slur.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Slur>, I>>(object: I): Slur {
    const message = createBaseSlur();
    message.slurId = object.slurId ?? "";
    message.slurStartId = object.slurStartId ?? "";
    message.slurEndId = object.slurEndId ?? "";
    return message;
  },
};

function createBaseTie(): Tie {
  return { tieStartId: "", tieEndId: "", tieId: "", startNote: undefined };
}

export const Tie: MessageFns<Tie> = {
  encode(message: Tie, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tieStartId !== "") {
      writer.uint32(10).string(message.tieStartId);
    }
    if (message.tieEndId !== "") {
      writer.uint32(18).string(message.tieEndId);
    }
    if (message.tieId !== "") {
      writer.uint32(26).string(message.tieId);
    }
    if (message.startNote !== undefined) {
      Note.encode(message.startNote, writer.uint32(34).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Tie {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTie();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.tieStartId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.tieEndId = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.tieId = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.startNote = Note.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Tie {
    return {
      tieStartId: isSet(object.tieStartId) ? globalThis.String(object.tieStartId) : "",
      tieEndId: isSet(object.tieEndId) ? globalThis.String(object.tieEndId) : "",
      tieId: isSet(object.tieId) ? globalThis.String(object.tieId) : "",
      startNote: isSet(object.startNote) ? Note.fromJSON(object.startNote) : undefined,
    };
  },

  toJSON(message: Tie): unknown {
    const obj: any = {};
    if (message.tieStartId !== "") {
      obj.tieStartId = message.tieStartId;
    }
    if (message.tieEndId !== "") {
      obj.tieEndId = message.tieEndId;
    }
    if (message.tieId !== "") {
      obj.tieId = message.tieId;
    }
    if (message.startNote !== undefined) {
      obj.startNote = Note.toJSON(message.startNote);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Tie>, I>>(base?: I): Tie {
    return Tie.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Tie>, I>>(object: I): Tie {
    const message = createBaseTie();
    message.tieStartId = object.tieStartId ?? "";
    message.tieEndId = object.tieEndId ?? "";
    message.tieId = object.tieId ?? "";
    message.startNote = (object.startNote !== undefined && object.startNote !== null)
      ? Note.fromPartial(object.startNote)
      : undefined;
    return message;
  },
};

function createBaseTrill(): Trill {
  return {
    id: "",
    position: "",
    trillStartNote: "",
    trillEndNote: undefined,
    accid: 0,
    waveLengthEndOffset: 0,
    waveEndXRel: 0,
  };
}

export const Trill: MessageFns<Trill> = {
  encode(message: Trill, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.position !== "") {
      writer.uint32(18).string(message.position);
    }
    if (message.trillStartNote !== "") {
      writer.uint32(26).string(message.trillStartNote);
    }
    if (message.trillEndNote !== undefined) {
      writer.uint32(34).string(message.trillEndNote);
    }
    if (message.accid !== 0) {
      writer.uint32(40).int32(message.accid);
    }
    if (message.waveLengthEndOffset !== 0) {
      writer.uint32(48).int32(message.waveLengthEndOffset);
    }
    if (message.waveEndXRel !== 0) {
      writer.uint32(56).int32(message.waveEndXRel);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Trill {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTrill();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.position = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.trillStartNote = reader.string();
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.trillEndNote = reader.string();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.accid = reader.int32() as any;
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.waveLengthEndOffset = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.waveEndXRel = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Trill {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      position: isSet(object.position) ? globalThis.String(object.position) : "",
      trillStartNote: isSet(object.trillStartNote) ? globalThis.String(object.trillStartNote) : "",
      trillEndNote: isSet(object.trillEndNote) ? globalThis.String(object.trillEndNote) : undefined,
      accid: isSet(object.accid) ? dataAccidentalWrittenFromJSON(object.accid) : 0,
      waveLengthEndOffset: isSet(object.waveLengthEndOffset) ? globalThis.Number(object.waveLengthEndOffset) : 0,
      waveEndXRel: isSet(object.waveEndXRel) ? globalThis.Number(object.waveEndXRel) : 0,
    };
  },

  toJSON(message: Trill): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.position !== "") {
      obj.position = message.position;
    }
    if (message.trillStartNote !== "") {
      obj.trillStartNote = message.trillStartNote;
    }
    if (message.trillEndNote !== undefined) {
      obj.trillEndNote = message.trillEndNote;
    }
    if (message.accid !== 0) {
      obj.accid = dataAccidentalWrittenToJSON(message.accid);
    }
    if (message.waveLengthEndOffset !== 0) {
      obj.waveLengthEndOffset = Math.round(message.waveLengthEndOffset);
    }
    if (message.waveEndXRel !== 0) {
      obj.waveEndXRel = Math.round(message.waveEndXRel);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Trill>, I>>(base?: I): Trill {
    return Trill.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Trill>, I>>(object: I): Trill {
    const message = createBaseTrill();
    message.id = object.id ?? "";
    message.position = object.position ?? "";
    message.trillStartNote = object.trillStartNote ?? "";
    message.trillEndNote = object.trillEndNote ?? undefined;
    message.accid = object.accid ?? 0;
    message.waveLengthEndOffset = object.waveLengthEndOffset ?? 0;
    message.waveEndXRel = object.waveEndXRel ?? 0;
    return message;
  },
};

function createBaseTurn(): Turn {
  return { id: "", position: "", turnRootNote: "" };
}

export const Turn: MessageFns<Turn> = {
  encode(message: Turn, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.position !== "") {
      writer.uint32(18).string(message.position);
    }
    if (message.turnRootNote !== "") {
      writer.uint32(26).string(message.turnRootNote);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Turn {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTurn();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.position = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.turnRootNote = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Turn {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      position: isSet(object.position) ? globalThis.String(object.position) : "",
      turnRootNote: isSet(object.turnRootNote) ? globalThis.String(object.turnRootNote) : "",
    };
  },

  toJSON(message: Turn): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.position !== "") {
      obj.position = message.position;
    }
    if (message.turnRootNote !== "") {
      obj.turnRootNote = message.turnRootNote;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Turn>, I>>(base?: I): Turn {
    return Turn.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Turn>, I>>(object: I): Turn {
    const message = createBaseTurn();
    message.id = object.id ?? "";
    message.position = object.position ?? "";
    message.turnRootNote = object.turnRootNote ?? "";
    return message;
  },
};

function createBaseMordent(): Mordent {
  return { id: "", position: "", mordentRootNote: "", isLong: 0 };
}

export const Mordent: MessageFns<Mordent> = {
  encode(message: Mordent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.position !== "") {
      writer.uint32(18).string(message.position);
    }
    if (message.mordentRootNote !== "") {
      writer.uint32(26).string(message.mordentRootNote);
    }
    if (message.isLong !== 0) {
      writer.uint32(32).int32(message.isLong);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Mordent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMordent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.position = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.mordentRootNote = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.isLong = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Mordent {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      position: isSet(object.position) ? globalThis.String(object.position) : "",
      mordentRootNote: isSet(object.mordentRootNote) ? globalThis.String(object.mordentRootNote) : "",
      isLong: isSet(object.isLong) ? globalThis.Number(object.isLong) : 0,
    };
  },

  toJSON(message: Mordent): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.position !== "") {
      obj.position = message.position;
    }
    if (message.mordentRootNote !== "") {
      obj.mordentRootNote = message.mordentRootNote;
    }
    if (message.isLong !== 0) {
      obj.isLong = Math.round(message.isLong);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Mordent>, I>>(base?: I): Mordent {
    return Mordent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Mordent>, I>>(object: I): Mordent {
    const message = createBaseMordent();
    message.id = object.id ?? "";
    message.position = object.position ?? "";
    message.mordentRootNote = object.mordentRootNote ?? "";
    message.isLong = object.isLong ?? 0;
    return message;
  },
};

function createBaseMeasureTimemapEntry(): MeasureTimemapEntry {
  return {
    measureIndex: 0,
    measureId: "",
    measureLeftBar: 0,
    measureRightBar: 0,
    volta: undefined,
    indexInXmlParent: 0,
    timestamp: 0,
    clefs: [],
    keyFifths: 0,
    keyMode: 0,
    notes: [],
  };
}

export const MeasureTimemapEntry: MessageFns<MeasureTimemapEntry> = {
  encode(message: MeasureTimemapEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.measureIndex !== 0) {
      writer.uint32(8).int32(message.measureIndex);
    }
    if (message.measureId !== "") {
      writer.uint32(18).string(message.measureId);
    }
    if (message.measureLeftBar !== 0) {
      writer.uint32(24).int32(message.measureLeftBar);
    }
    if (message.measureRightBar !== 0) {
      writer.uint32(32).int32(message.measureRightBar);
    }
    if (message.volta !== undefined) {
      volta.encode(message.volta, writer.uint32(42).fork()).join();
    }
    if (message.indexInXmlParent !== 0) {
      writer.uint32(48).int32(message.indexInXmlParent);
    }
    if (message.timestamp !== 0) {
      writer.uint32(56).int32(message.timestamp);
    }
    for (const v of message.clefs) {
      clef.encode(v!, writer.uint32(66).fork()).join();
    }
    if (message.keyFifths !== 0) {
      writer.uint32(72).int32(message.keyFifths);
    }
    if (message.keyMode !== 0) {
      writer.uint32(80).int32(message.keyMode);
    }
    for (const v of message.notes) {
      Note.encode(v!, writer.uint32(90).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MeasureTimemapEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMeasureTimemapEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.measureIndex = reader.int32();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.measureId = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.measureLeftBar = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.measureRightBar = reader.int32() as any;
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.volta = volta.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.indexInXmlParent = reader.int32();
          continue;
        case 7:
          if (tag !== 56) {
            break;
          }

          message.timestamp = reader.int32();
          continue;
        case 8:
          if (tag !== 66) {
            break;
          }

          message.clefs.push(clef.decode(reader, reader.uint32()));
          continue;
        case 9:
          if (tag !== 72) {
            break;
          }

          message.keyFifths = reader.int32();
          continue;
        case 10:
          if (tag !== 80) {
            break;
          }

          message.keyMode = reader.int32() as any;
          continue;
        case 11:
          if (tag !== 90) {
            break;
          }

          message.notes.push(Note.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MeasureTimemapEntry {
    return {
      measureIndex: isSet(object.measureIndex) ? globalThis.Number(object.measureIndex) : 0,
      measureId: isSet(object.measureId) ? globalThis.String(object.measureId) : "",
      measureLeftBar: isSet(object.measureLeftBar) ? dataMeasureBarlineFromJSON(object.measureLeftBar) : 0,
      measureRightBar: isSet(object.measureRightBar) ? dataMeasureBarlineFromJSON(object.measureRightBar) : 0,
      volta: isSet(object.volta) ? volta.fromJSON(object.volta) : undefined,
      indexInXmlParent: isSet(object.indexInXmlParent) ? globalThis.Number(object.indexInXmlParent) : 0,
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
      clefs: globalThis.Array.isArray(object?.clefs) ? object.clefs.map((e: any) => clef.fromJSON(e)) : [],
      keyFifths: isSet(object.keyFifths) ? globalThis.Number(object.keyFifths) : 0,
      keyMode: isSet(object.keyMode) ? dataModeFromJSON(object.keyMode) : 0,
      notes: globalThis.Array.isArray(object?.notes) ? object.notes.map((e: any) => Note.fromJSON(e)) : [],
    };
  },

  toJSON(message: MeasureTimemapEntry): unknown {
    const obj: any = {};
    if (message.measureIndex !== 0) {
      obj.measureIndex = Math.round(message.measureIndex);
    }
    if (message.measureId !== "") {
      obj.measureId = message.measureId;
    }
    if (message.measureLeftBar !== 0) {
      obj.measureLeftBar = dataMeasureBarlineToJSON(message.measureLeftBar);
    }
    if (message.measureRightBar !== 0) {
      obj.measureRightBar = dataMeasureBarlineToJSON(message.measureRightBar);
    }
    if (message.volta !== undefined) {
      obj.volta = volta.toJSON(message.volta);
    }
    if (message.indexInXmlParent !== 0) {
      obj.indexInXmlParent = Math.round(message.indexInXmlParent);
    }
    if (message.timestamp !== 0) {
      obj.timestamp = Math.round(message.timestamp);
    }
    if (message.clefs?.length) {
      obj.clefs = message.clefs.map((e) => clef.toJSON(e));
    }
    if (message.keyFifths !== 0) {
      obj.keyFifths = Math.round(message.keyFifths);
    }
    if (message.keyMode !== 0) {
      obj.keyMode = dataModeToJSON(message.keyMode);
    }
    if (message.notes?.length) {
      obj.notes = message.notes.map((e) => Note.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MeasureTimemapEntry>, I>>(base?: I): MeasureTimemapEntry {
    return MeasureTimemapEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MeasureTimemapEntry>, I>>(object: I): MeasureTimemapEntry {
    const message = createBaseMeasureTimemapEntry();
    message.measureIndex = object.measureIndex ?? 0;
    message.measureId = object.measureId ?? "";
    message.measureLeftBar = object.measureLeftBar ?? 0;
    message.measureRightBar = object.measureRightBar ?? 0;
    message.volta = (object.volta !== undefined && object.volta !== null) ? volta.fromPartial(object.volta) : undefined;
    message.indexInXmlParent = object.indexInXmlParent ?? 0;
    message.timestamp = object.timestamp ?? 0;
    message.clefs = object.clefs?.map((e) => clef.fromPartial(e)) || [];
    message.keyFifths = object.keyFifths ?? 0;
    message.keyMode = object.keyMode ?? 0;
    message.notes = object.notes?.map((e) => Note.fromPartial(e)) || [];
    return message;
  },
};

function createBasevolta(): volta {
  return { endingStart: undefined, endingStop: undefined };
}

export const volta: MessageFns<volta> = {
  encode(message: volta, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.endingStart !== undefined) {
      ending.encode(message.endingStart, writer.uint32(10).fork()).join();
    }
    if (message.endingStop !== undefined) {
      ending.encode(message.endingStop, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): volta {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasevolta();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.endingStart = ending.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.endingStop = ending.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): volta {
    return {
      endingStart: isSet(object.endingStart) ? ending.fromJSON(object.endingStart) : undefined,
      endingStop: isSet(object.endingStop) ? ending.fromJSON(object.endingStop) : undefined,
    };
  },

  toJSON(message: volta): unknown {
    const obj: any = {};
    if (message.endingStart !== undefined) {
      obj.endingStart = ending.toJSON(message.endingStart);
    }
    if (message.endingStop !== undefined) {
      obj.endingStop = ending.toJSON(message.endingStop);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<volta>, I>>(base?: I): volta {
    return volta.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<volta>, I>>(object: I): volta {
    const message = createBasevolta();
    message.endingStart = (object.endingStart !== undefined && object.endingStart !== null)
      ? ending.fromPartial(object.endingStart)
      : undefined;
    message.endingStop = (object.endingStop !== undefined && object.endingStop !== null)
      ? ending.fromPartial(object.endingStop)
      : undefined;
    return message;
  },
};

function createBaseending(): ending {
  return { endingNumber: "", endingText: "", endingType: "" };
}

export const ending: MessageFns<ending> = {
  encode(message: ending, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.endingNumber !== "") {
      writer.uint32(10).string(message.endingNumber);
    }
    if (message.endingText !== "") {
      writer.uint32(18).string(message.endingText);
    }
    if (message.endingType !== "") {
      writer.uint32(26).string(message.endingType);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ending {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseending();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.endingNumber = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.endingText = reader.string();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.endingType = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ending {
    return {
      endingNumber: isSet(object.endingNumber) ? globalThis.String(object.endingNumber) : "",
      endingText: isSet(object.endingText) ? globalThis.String(object.endingText) : "",
      endingType: isSet(object.endingType) ? globalThis.String(object.endingType) : "",
    };
  },

  toJSON(message: ending): unknown {
    const obj: any = {};
    if (message.endingNumber !== "") {
      obj.endingNumber = message.endingNumber;
    }
    if (message.endingText !== "") {
      obj.endingText = message.endingText;
    }
    if (message.endingType !== "") {
      obj.endingType = message.endingType;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ending>, I>>(base?: I): ending {
    return ending.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ending>, I>>(object: I): ending {
    const message = createBaseending();
    message.endingNumber = object.endingNumber ?? "";
    message.endingText = object.endingText ?? "";
    message.endingType = object.endingType ?? "";
    return message;
  },
};

function createBaseclef(): clef {
  return { shape: 0, line: 0 };
}

export const clef: MessageFns<clef> = {
  encode(message: clef, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.shape !== 0) {
      writer.uint32(8).int32(message.shape);
    }
    if (message.line !== 0) {
      writer.uint32(16).int32(message.line);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): clef {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseclef();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.shape = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.line = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): clef {
    return {
      shape: isSet(object.shape) ? dataClefshapeFromJSON(object.shape) : 0,
      line: isSet(object.line) ? globalThis.Number(object.line) : 0,
    };
  },

  toJSON(message: clef): unknown {
    const obj: any = {};
    if (message.shape !== 0) {
      obj.shape = dataClefshapeToJSON(message.shape);
    }
    if (message.line !== 0) {
      obj.line = Math.round(message.line);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<clef>, I>>(base?: I): clef {
    return clef.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<clef>, I>>(object: I): clef {
    const message = createBaseclef();
    message.shape = object.shape ?? 0;
    message.line = object.line ?? 0;
    return message;
  },
};

function createBaseornamentNotesIndToDelete(): ornamentNotesIndToDelete {
  return { parentOrnamentNote: undefined, measureIndex: 0, eventIndexes: [] };
}

export const ornamentNotesIndToDelete: MessageFns<ornamentNotesIndToDelete> = {
  encode(message: ornamentNotesIndToDelete, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.parentOrnamentNote !== undefined) {
      Note.encode(message.parentOrnamentNote, writer.uint32(10).fork()).join();
    }
    if (message.measureIndex !== 0) {
      writer.uint32(16).int32(message.measureIndex);
    }
    writer.uint32(26).fork();
    for (const v of message.eventIndexes) {
      writer.int32(v);
    }
    writer.join();
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ornamentNotesIndToDelete {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseornamentNotesIndToDelete();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.parentOrnamentNote = Note.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.measureIndex = reader.int32();
          continue;
        case 3:
          if (tag === 24) {
            message.eventIndexes.push(reader.int32());

            continue;
          }

          if (tag === 26) {
            const end2 = reader.uint32() + reader.pos;
            while (reader.pos < end2) {
              message.eventIndexes.push(reader.int32());
            }

            continue;
          }

          break;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ornamentNotesIndToDelete {
    return {
      parentOrnamentNote: isSet(object.parentOrnamentNote) ? Note.fromJSON(object.parentOrnamentNote) : undefined,
      measureIndex: isSet(object.measureIndex) ? globalThis.Number(object.measureIndex) : 0,
      eventIndexes: globalThis.Array.isArray(object?.eventIndexes)
        ? object.eventIndexes.map((e: any) => globalThis.Number(e))
        : [],
    };
  },

  toJSON(message: ornamentNotesIndToDelete): unknown {
    const obj: any = {};
    if (message.parentOrnamentNote !== undefined) {
      obj.parentOrnamentNote = Note.toJSON(message.parentOrnamentNote);
    }
    if (message.measureIndex !== 0) {
      obj.measureIndex = Math.round(message.measureIndex);
    }
    if (message.eventIndexes?.length) {
      obj.eventIndexes = message.eventIndexes.map((e) => Math.round(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ornamentNotesIndToDelete>, I>>(base?: I): ornamentNotesIndToDelete {
    return ornamentNotesIndToDelete.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ornamentNotesIndToDelete>, I>>(object: I): ornamentNotesIndToDelete {
    const message = createBaseornamentNotesIndToDelete();
    message.parentOrnamentNote = (object.parentOrnamentNote !== undefined && object.parentOrnamentNote !== null)
      ? Note.fromPartial(object.parentOrnamentNote)
      : undefined;
    message.measureIndex = object.measureIndex ?? 0;
    message.eventIndexes = object.eventIndexes?.map((e) => e) || [];
    return message;
  },
};

function createBasemidiNoteEvent(): midiNoteEvent {
  return { tick: 0, noteNumber: 0, noteName: "", velocity: 0, channel: 0 };
}

export const midiNoteEvent: MessageFns<midiNoteEvent> = {
  encode(message: midiNoteEvent, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.tick !== 0) {
      writer.uint32(8).int32(message.tick);
    }
    if (message.noteNumber !== 0) {
      writer.uint32(16).int32(message.noteNumber);
    }
    if (message.noteName !== "") {
      writer.uint32(26).string(message.noteName);
    }
    if (message.velocity !== 0) {
      writer.uint32(32).int32(message.velocity);
    }
    if (message.channel !== 0) {
      writer.uint32(40).int32(message.channel);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): midiNoteEvent {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasemidiNoteEvent();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.tick = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.noteNumber = reader.int32();
          continue;
        case 3:
          if (tag !== 26) {
            break;
          }

          message.noteName = reader.string();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.velocity = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.channel = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): midiNoteEvent {
    return {
      tick: isSet(object.tick) ? globalThis.Number(object.tick) : 0,
      noteNumber: isSet(object.noteNumber) ? globalThis.Number(object.noteNumber) : 0,
      noteName: isSet(object.noteName) ? globalThis.String(object.noteName) : "",
      velocity: isSet(object.velocity) ? globalThis.Number(object.velocity) : 0,
      channel: isSet(object.channel) ? globalThis.Number(object.channel) : 0,
    };
  },

  toJSON(message: midiNoteEvent): unknown {
    const obj: any = {};
    if (message.tick !== 0) {
      obj.tick = Math.round(message.tick);
    }
    if (message.noteNumber !== 0) {
      obj.noteNumber = Math.round(message.noteNumber);
    }
    if (message.noteName !== "") {
      obj.noteName = message.noteName;
    }
    if (message.velocity !== 0) {
      obj.velocity = Math.round(message.velocity);
    }
    if (message.channel !== 0) {
      obj.channel = Math.round(message.channel);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<midiNoteEvent>, I>>(base?: I): midiNoteEvent {
    return midiNoteEvent.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<midiNoteEvent>, I>>(object: I): midiNoteEvent {
    const message = createBasemidiNoteEvent();
    message.tick = object.tick ?? 0;
    message.noteNumber = object.noteNumber ?? 0;
    message.noteName = object.noteName ?? "";
    message.velocity = object.velocity ?? 0;
    message.channel = object.channel ?? 0;
    return message;
  },
};

function createBaseMidiEvents(): MidiEvents {
  return { noteOnEvents: [], noteOffEvents: [] };
}

export const MidiEvents: MessageFns<MidiEvents> = {
  encode(message: MidiEvents, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.noteOnEvents) {
      midiNoteEvent.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.noteOffEvents) {
      midiNoteEvent.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MidiEvents {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMidiEvents();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.noteOnEvents.push(midiNoteEvent.decode(reader, reader.uint32()));
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.noteOffEvents.push(midiNoteEvent.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MidiEvents {
    return {
      noteOnEvents: globalThis.Array.isArray(object?.noteOnEvents)
        ? object.noteOnEvents.map((e: any) => midiNoteEvent.fromJSON(e))
        : [],
      noteOffEvents: globalThis.Array.isArray(object?.noteOffEvents)
        ? object.noteOffEvents.map((e: any) => midiNoteEvent.fromJSON(e))
        : [],
    };
  },

  toJSON(message: MidiEvents): unknown {
    const obj: any = {};
    if (message.noteOnEvents?.length) {
      obj.noteOnEvents = message.noteOnEvents.map((e) => midiNoteEvent.toJSON(e));
    }
    if (message.noteOffEvents?.length) {
      obj.noteOffEvents = message.noteOffEvents.map((e) => midiNoteEvent.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MidiEvents>, I>>(base?: I): MidiEvents {
    return MidiEvents.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MidiEvents>, I>>(object: I): MidiEvents {
    const message = createBaseMidiEvents();
    message.noteOnEvents = object.noteOnEvents?.map((e) => midiNoteEvent.fromPartial(e)) || [];
    message.noteOffEvents = object.noteOffEvents?.map((e) => midiNoteEvent.fromPartial(e)) || [];
    return message;
  },
};

function createBasePossibleEncountersData(): PossibleEncountersData {
  return { possibleEncounters: [] };
}

export const PossibleEncountersData: MessageFns<PossibleEncountersData> = {
  encode(message: PossibleEncountersData, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.possibleEncounters) {
      Note.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): PossibleEncountersData {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBasePossibleEncountersData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.possibleEncounters.push(Note.decode(reader, reader.uint32()));
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): PossibleEncountersData {
    return {
      possibleEncounters: globalThis.Array.isArray(object?.possibleEncounters)
        ? object.possibleEncounters.map((e: any) => Note.fromJSON(e))
        : [],
    };
  },

  toJSON(message: PossibleEncountersData): unknown {
    const obj: any = {};
    if (message.possibleEncounters?.length) {
      obj.possibleEncounters = message.possibleEncounters.map((e) => Note.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<PossibleEncountersData>, I>>(base?: I): PossibleEncountersData {
    return PossibleEncountersData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<PossibleEncountersData>, I>>(object: I): PossibleEncountersData {
    const message = createBasePossibleEncountersData();
    message.possibleEncounters = object.possibleEncounters?.map((e) => Note.fromPartial(e)) || [];
    return message;
  },
};

function createBaseCoord(): Coord {
  return { measure: 0, offset: 0, xCoord: 0, yCoord: 0, absoluteTime: 0 };
}

export const Coord: MessageFns<Coord> = {
  encode(message: Coord, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.measure !== 0) {
      writer.uint32(8).int32(message.measure);
    }
    if (message.offset !== 0) {
      writer.uint32(16).int64(message.offset);
    }
    if (message.xCoord !== 0) {
      writer.uint32(24).int32(message.xCoord);
    }
    if (message.yCoord !== 0) {
      writer.uint32(32).int32(message.yCoord);
    }
    if (message.absoluteTime !== 0) {
      writer.uint32(40).int64(message.absoluteTime);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Coord {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCoord();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.measure = reader.int32();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.offset = longToNumber(reader.int64());
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.xCoord = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.yCoord = reader.int32();
          continue;
        case 5:
          if (tag !== 40) {
            break;
          }

          message.absoluteTime = longToNumber(reader.int64());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Coord {
    return {
      measure: isSet(object.measure) ? globalThis.Number(object.measure) : 0,
      offset: isSet(object.offset) ? globalThis.Number(object.offset) : 0,
      xCoord: isSet(object.xCoord) ? globalThis.Number(object.xCoord) : 0,
      yCoord: isSet(object.yCoord) ? globalThis.Number(object.yCoord) : 0,
      absoluteTime: isSet(object.absoluteTime) ? globalThis.Number(object.absoluteTime) : 0,
    };
  },

  toJSON(message: Coord): unknown {
    const obj: any = {};
    if (message.measure !== 0) {
      obj.measure = Math.round(message.measure);
    }
    if (message.offset !== 0) {
      obj.offset = Math.round(message.offset);
    }
    if (message.xCoord !== 0) {
      obj.xCoord = Math.round(message.xCoord);
    }
    if (message.yCoord !== 0) {
      obj.yCoord = Math.round(message.yCoord);
    }
    if (message.absoluteTime !== 0) {
      obj.absoluteTime = Math.round(message.absoluteTime);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<Coord>, I>>(base?: I): Coord {
    return Coord.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<Coord>, I>>(object: I): Coord {
    const message = createBaseCoord();
    message.measure = object.measure ?? 0;
    message.offset = object.offset ?? 0;
    message.xCoord = object.xCoord ?? 0;
    message.yCoord = object.yCoord ?? 0;
    message.absoluteTime = object.absoluteTime ?? 0;
    return message;
  },
};

function createBaseSelectionRange(): SelectionRange {
  return { start: undefined, end: undefined };
}

export const SelectionRange: MessageFns<SelectionRange> = {
  encode(message: SelectionRange, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.start !== undefined) {
      Coord.encode(message.start, writer.uint32(10).fork()).join();
    }
    if (message.end !== undefined) {
      Coord.encode(message.end, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SelectionRange {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSelectionRange();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.start = Coord.decode(reader, reader.uint32());
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.end = Coord.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SelectionRange {
    return {
      start: isSet(object.start) ? Coord.fromJSON(object.start) : undefined,
      end: isSet(object.end) ? Coord.fromJSON(object.end) : undefined,
    };
  },

  toJSON(message: SelectionRange): unknown {
    const obj: any = {};
    if (message.start !== undefined) {
      obj.start = Coord.toJSON(message.start);
    }
    if (message.end !== undefined) {
      obj.end = Coord.toJSON(message.end);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SelectionRange>, I>>(base?: I): SelectionRange {
    return SelectionRange.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SelectionRange>, I>>(object: I): SelectionRange {
    const message = createBaseSelectionRange();
    message.start = (object.start !== undefined && object.start !== null) ? Coord.fromPartial(object.start) : undefined;
    message.end = (object.end !== undefined && object.end !== null) ? Coord.fromPartial(object.end) : undefined;
    return message;
  },
};

function createBaseCursorPosition(): CursorPosition {
  return { noteId: "", measureIndex: 0, x: 0, y: 0, relativeX: 0, systemIndex: 0 };
}

export const CursorPosition: MessageFns<CursorPosition> = {
  encode(message: CursorPosition, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.noteId !== "") {
      writer.uint32(10).string(message.noteId);
    }
    if (message.measureIndex !== 0) {
      writer.uint32(16).int32(message.measureIndex);
    }
    if (message.x !== 0) {
      writer.uint32(24).int32(message.x);
    }
    if (message.y !== 0) {
      writer.uint32(32).int32(message.y);
    }
    if (message.relativeX !== 0) {
      writer.uint32(41).double(message.relativeX);
    }
    if (message.systemIndex !== 0) {
      writer.uint32(48).int32(message.systemIndex);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CursorPosition {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCursorPosition();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.noteId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.measureIndex = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.x = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.y = reader.int32();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.relativeX = reader.double();
          continue;
        case 6:
          if (tag !== 48) {
            break;
          }

          message.systemIndex = reader.int32();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CursorPosition {
    return {
      noteId: isSet(object.noteId) ? globalThis.String(object.noteId) : "",
      measureIndex: isSet(object.measureIndex) ? globalThis.Number(object.measureIndex) : 0,
      x: isSet(object.x) ? globalThis.Number(object.x) : 0,
      y: isSet(object.y) ? globalThis.Number(object.y) : 0,
      relativeX: isSet(object.relativeX) ? globalThis.Number(object.relativeX) : 0,
      systemIndex: isSet(object.systemIndex) ? globalThis.Number(object.systemIndex) : 0,
    };
  },

  toJSON(message: CursorPosition): unknown {
    const obj: any = {};
    if (message.noteId !== "") {
      obj.noteId = message.noteId;
    }
    if (message.measureIndex !== 0) {
      obj.measureIndex = Math.round(message.measureIndex);
    }
    if (message.x !== 0) {
      obj.x = Math.round(message.x);
    }
    if (message.y !== 0) {
      obj.y = Math.round(message.y);
    }
    if (message.relativeX !== 0) {
      obj.relativeX = message.relativeX;
    }
    if (message.systemIndex !== 0) {
      obj.systemIndex = Math.round(message.systemIndex);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CursorPosition>, I>>(base?: I): CursorPosition {
    return CursorPosition.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CursorPosition>, I>>(object: I): CursorPosition {
    const message = createBaseCursorPosition();
    message.noteId = object.noteId ?? "";
    message.measureIndex = object.measureIndex ?? 0;
    message.x = object.x ?? 0;
    message.y = object.y ?? 0;
    message.relativeX = object.relativeX ?? 0;
    message.systemIndex = object.systemIndex ?? 0;
    return message;
  },
};

function createBaseMidiMessage(): MidiMessage {
  return { type: 0, noteNumber: 0, velocity: 0, channel: 0, timestamp: 0 };
}

export const MidiMessage: MessageFns<MidiMessage> = {
  encode(message: MidiMessage, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.type !== 0) {
      writer.uint32(8).int32(message.type);
    }
    if (message.noteNumber !== 0) {
      writer.uint32(16).int32(message.noteNumber);
    }
    if (message.velocity !== 0) {
      writer.uint32(24).int32(message.velocity);
    }
    if (message.channel !== 0) {
      writer.uint32(32).int32(message.channel);
    }
    if (message.timestamp !== 0) {
      writer.uint32(41).double(message.timestamp);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): MidiMessage {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseMidiMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 8) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.noteNumber = reader.int32();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.velocity = reader.int32();
          continue;
        case 4:
          if (tag !== 32) {
            break;
          }

          message.channel = reader.int32();
          continue;
        case 5:
          if (tag !== 41) {
            break;
          }

          message.timestamp = reader.double();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): MidiMessage {
    return {
      type: isSet(object.type) ? midiMessageTypeFromJSON(object.type) : 0,
      noteNumber: isSet(object.noteNumber) ? globalThis.Number(object.noteNumber) : 0,
      velocity: isSet(object.velocity) ? globalThis.Number(object.velocity) : 0,
      channel: isSet(object.channel) ? globalThis.Number(object.channel) : 0,
      timestamp: isSet(object.timestamp) ? globalThis.Number(object.timestamp) : 0,
    };
  },

  toJSON(message: MidiMessage): unknown {
    const obj: any = {};
    if (message.type !== 0) {
      obj.type = midiMessageTypeToJSON(message.type);
    }
    if (message.noteNumber !== 0) {
      obj.noteNumber = Math.round(message.noteNumber);
    }
    if (message.velocity !== 0) {
      obj.velocity = Math.round(message.velocity);
    }
    if (message.channel !== 0) {
      obj.channel = Math.round(message.channel);
    }
    if (message.timestamp !== 0) {
      obj.timestamp = message.timestamp;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<MidiMessage>, I>>(base?: I): MidiMessage {
    return MidiMessage.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<MidiMessage>, I>>(object: I): MidiMessage {
    const message = createBaseMidiMessage();
    message.type = object.type ?? 0;
    message.noteNumber = object.noteNumber ?? 0;
    message.velocity = object.velocity ?? 0;
    message.channel = object.channel ?? 0;
    message.timestamp = object.timestamp ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
